<template>
  <div id="app" :class="index ? 'index' :'home'">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
export default {
  name: 'app',

  provide() { // 父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload,

    }
  },
  data() {
    return {
      isRouterAlive: true, // 控制视图是否显示的变量
      index: true
    }
  },
  watch: {
    // 方法1
    '$route'(to, from) { //监听路由是否变化
      if (to.path == "/index") { //跳转到哪个页面
        this.index = true
      } else {
        this.index = false
      }
    },
  },

  methods: {
    reload() {
      this.isRouterAlive = false //先关闭，
      this.$nextTick(() => {
        this.isRouterAlive = true //再打开
      })
    }
  }
}
</script>
<style lang="less">
@import './base.less';

html,
body {
  width: 100%;
  height: 100%;
  background: #f0f0f0;
  word-break: break-all;
  word-wrap: break-word;
}

.index {
  overflow-y: scroll;
}

.home {
  overflow: hidden;
}

#app {
  width: 100%;
  height: 100%;
  font-family: SourceHanSansCN-Normal, sans-serif;
  font-weight: 400;
}

.ivu-select-dropdown {
  ul {
    max-width: 120px;
    padding-top: 8px;

    li {
      width: 100%;
      height: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap; /**不换行**/
      display: inline-block;
    }
  }
}

.el-cascader-panel {
  height: 200px;
}
</style>
